import React from 'react';
import './StatCard.css';

const StatCard = ({ title, value, change, icon, color = 'blue' }) => {
  return (
    <div className={`stat-card stat-card-${color}`}>
      <div className="stat-card-header">
        <div className="stat-icon">
          {icon}
        </div>
        <div className="stat-change">
          {change}
        </div>
      </div>
      
      <div className="stat-content">
        <h3 className="stat-title">{title}</h3>
        <div className="stat-value">{value}</div>
      </div>
    </div>
  );
};

export default StatCard; 